import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useCoreTheme } from '@liefersoft/pos-ui-core'
import { setSystemColorTheme } from '../../redux/action/system'

const ThemeClassBridge = ({ children }) => {
	const { colorTheme } = useCoreTheme()
	const dispatch = useDispatch()

	useEffect(() => {
		document.documentElement.classList.toggle('lp-dark', colorTheme === 'DARK')
	}, [colorTheme])

	useEffect(() => {
		dispatch(setSystemColorTheme(colorTheme))
	}, [colorTheme, dispatch])

	return <>{children}</>
}

ThemeClassBridge.displayName = 'ThemeClassBridge'
export default ThemeClassBridge
